import {
  EDIT_FEATURE, DELETE_FEATURE, CREATE_FEATURE, CREATE_FEATURE_SUCCESS, UPDATE_FEATURE_SUCCESS,
  UPDATE_FEATURE, DELETE_FEATURE_SUCCESS, FETCH_ALL_FEATURE, FETCH_ALL_FEATURE_SUCCESS,SET_FEATURE,SET_ROLE
} from 'constants/features.constants'
import { startLoader } from 'actions/general.action';

export const setFeature = (key, value) => {
  return {
    type : SET_FEATURE,
    key: key,
    value: value
  }
}

export const setRoles = (key, value) => {
return {
  type: SET_ROLE,
  key:key,
  value:value
}
}

export const fetchFeatures = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_FEATURE,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchFeaturesSuccess = (data) => {
  return {
    type: FETCH_ALL_FEATURE_SUCCESS,
    payload: data
  };
};

export const deleteFeature = (id) => {
  return {
    type: DELETE_FEATURE,
    payload: id
  };
};

export const editFeature = (id) => {
  return {
    type: EDIT_FEATURE,
    payload: id
  };
};

export const createFeature = (payload) => {
  console.log(payload)
  return {
    type: CREATE_FEATURE,
    payload: payload
  };
};

export const createFeatureSuccess = (payload) => {
  return {
    type: CREATE_FEATURE_SUCCESS,
    payload: payload
  };
};

export const updateFeatureSuccess = (data) => {
  return {
    type: UPDATE_FEATURE_SUCCESS,
    payload: data
  };
};

export const deleteFeatureSuccess = (data) => {
  return {
    type: DELETE_FEATURE_SUCCESS,
    payload: data
  };
};

export const updateFeature = (payload) => {
  return {
    type: UPDATE_FEATURE,
    payload: payload
  };
}; 